import PenMenu from '../toolbars/PenMenu';
import Stylus from './Stylus';
import type WhiteboardController from '../controllers/WhiteboardController';

class StylusCurrentPen extends Stylus {
  private currentStylus: Stylus;

  constructor({
    controller,
    currentStylus,
  }: {
    controller: WhiteboardController;
    currentStylus: Stylus;
  }) {
    super({ controller });
    this.currentStylus = currentStylus;
  }

  activate(): void {
    this.currentStylus.activate();
  }

  subMenu() {
    return PenMenu;
  }

  subMenuName() {
    return 'pen';
  }

  renderIcon() {
    return this.currentStylus.renderIcon();
  }

  description(): string {
    return 'Pen';
  }

  setCurrentStylus(stylus: Stylus): void {
    this.currentStylus = stylus;
  }

  cursor() {
    return this.currentStylus.cursor();
  }

  alwaysLockWhenSelected() {
    return this.currentStylus.alwaysLockWhenSelected();
  }

  drawingComplete() {
    this.currentStylus.drawingComplete();
  }

  stylusId() {
    return 'pen';
  }
}

export default StylusCurrentPen;
